module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "shopping-cart-img"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("message.contacts")) + "\n        ")]), _vm._v(" "), (_vm.errormsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "error-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.errormsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.correctmsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "correct-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.correctmsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list-block customer-login "
  }, [_c('div', {
    staticClass: "col-main account_center"
  }, [_c('div', {
    staticClass: "account-form",
    attrs: {
      "id": "form-validate"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer_name),
      expression: "customer_name"
    }],
    staticClass: "input-text required-entry",
    attrs: {
      "placeholder": "Your Name",
      "id": "contacts_name",
      "name": "editForm[name]",
      "title": "First Name",
      "maxlength": "255",
      "type": "text"
    },
    domProps: {
      "value": (_vm.customer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer_name = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input-text required-entry",
    attrs: {
      "placeholder": "Your Email Address",
      "id": "contacts_email",
      "name": "editForm[email]",
      "title": "email",
      "maxlength": "255",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephone),
      expression: "telephone"
    }],
    staticClass: "input-text required-entry ",
    attrs: {
      "placeholder": "Your telephone",
      "name": "editForm[telephone]",
      "id": "contacts_telephone",
      "title": "telephone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telephone = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    attrs: {
      "placeholder": "Your Comment",
      "name": "editForm[comment]",
      "id": "contacts_comment"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), (_vm.contactsCaptchaActive) ? _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captcha),
      expression: "captcha"
    }],
    staticClass: "login-captcha-input",
    attrs: {
      "placeholder": "captcha",
      "type": "text",
      "name": "editForm[captcha]",
      "value": "",
      "size": "10"
    },
    domProps: {
      "value": (_vm.captcha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captcha = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "login-captcha-img",
    attrs: {
      "title": "click refresh",
      "src": _vm.captchaFile,
      "align": "absbottom"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon icon-refresh",
    on: {
      "click": function($event) {
        return _vm.reflushCaptcha()
      }
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons-set"
  }, [_c('p', [_c('a', {
    staticClass: "button button-fill",
    attrs: {
      "href": "javascript:void(0)",
      "id": "js_contactBtn"
    },
    on: {
      "click": function($event) {
        return _vm.submitContacts()
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("message.contact_us")) + "\n                            ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "mailtous"
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm.$t("message.our_email_address")) + "\n                ")]), _vm._v(": \n                "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.contacts_email
    }
  }, [_vm._v(_vm._s(_vm.contacts_email))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-password"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-130f95fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/customer/Contacts.vue
// module id = 232
// module chunks = 1